
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/UpdatePassword/UpdatePassword.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./UpdatePassword.html');
        
        var script = require('./UpdatePassword.ts').default;
        module.exports = require('./UpdatePassword.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    